exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n  width: 30%;\n  max-width: 50%; }\n\n.modal-footer,\n.modal-body {\n  border-top: 1px solid #eceeef; }\n\n.modal-header {\n  padding: 10px 15px; }\n\n.modal-body {\n  padding: 25px 30px; }\n  .modal-body .has-feedback i {\n    top: 26px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/stranka/FrontOffice/src/app/modals/activate-user/activate-user.scss
// module id = ../../../../../src/app/modals/activate-user/activate-user.scss
// module chunks = main